import type { ReactNode, Ref } from "react";
import { cn } from "@/lib/utils";

/** Top-of-form error / status banner (auth, tools, projects). */
export function FormAlert({
  children,
  className,
  ref,
}: {
  children: ReactNode;
  className?: string;
  ref?: Ref<HTMLDivElement>;
}) {
  if (!children) return null;
  return (
    <div
      ref={ref}
      role="alert"
      className={cn(
        "rounded-[14px] border border-[rgba(180,60,50,0.22)] bg-[rgba(180,60,50,0.06)] px-4 py-3 text-[13.5px] leading-[1.45] text-ink",
        className,
      )}
    >
      {children}
    </div>
  );
}
